export default __webpack_public_path__ + "static/media/gitara.f4a3d27a.jpg";